import React, { useEffect, useState } from 'react'
import './EventsDashboard.css'
import { Link, Redirect } from 'react-router-dom'
import { IoIosAdd, IoMdHourglass } from 'react-icons/io'
import { BiCalendar, BiCheckCircle, BiMoney } from 'react-icons/bi'
import Axios from 'axios'
import { IoStar } from 'react-icons/io5'
import ClipLoader from 'react-spinners/ClipLoader'
import { API_URL } from '../../config'

const url = `${API_URL}/apps/kscanner/webservices.php`

const SummaryCard = ({ title, count, icon }) => (
  <div className="summary-card">
    <div className="card-icon">{icon}</div>
    <div className="card-content">
      <h4>{title}</h4>
      <p>{count}</p>
    </div>
  </div>
)

function formatCurrency(amount) {
  const number = parseFloat(amount)
  if (isNaN(number)) return '0.00'

  return number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

const EventRow = ({ event }) => {
  const sales = parseFloat(event.sales.replace(/\s/g, '')) || 0
  const net = parseFloat(event.net.replace(/\s/g, '')) || 0

  const netRevenue = sales - net

  return (
    <tr>
      <td>
        {event.organiser && event.organiser.length > 17
          ? event.organiser.substring(0, 17).trim() + '...'
          : event.organiser ||
            (event.businessname && event.businessname.length > 17
              ? event.businessname.substring(0, 17).trim() + '...'
              : event.businessname)}
      </td>
      <td>
        {event.is_sponsorship == 1 ? (
          <label className="sponsored-badge-dashboard">
            <IoStar />
          </label>
        ) : (
          ''
        )}
        &nbsp;
        {event.eventname.length > 17
          ? event.eventname.substring(0, 17).trim() + '...'
          : event.eventname}
      </td>
      <td>{event.eventday}</td>
      <td>
        <span
          className={`status-badge ${
            event.budget <= 0 ? 'draft' : event.eventstatus.toLowerCase()
          }`}
        >
          {event.budget <= 0 ? 'draft' : event.eventstatus}
        </span>
      </td>
      <td>{event.sold}</td>
      <td>{event.admissions}</td>
      <td>R{formatCurrency(sales)}</td>
      <td>R{formatCurrency(netRevenue)}</td>
      <td>
        <span className={`payout-badge ${event.payoutstatus.toLowerCase()}`}>
          {event.payoutstatus}
        </span>
      </td>
      <td>
        <span
          className={`campaign-badge ${event.campaignstatus === 'running' ? 'active' : 'inactive'}`}
        >
          {event.campaignstatus === 'running' ? 'Active' : 'Inactive'}
        </span>
      </td>
      <td>
        <Link
          to={{
            pathname: './editevent',
            state: {
              is_sponsorship: event.is_sponsorship,
              campaignstatus: event.campaignstatus,
              eventid: event.eventid,
              eventname: event.eventname,
              poster: event.poster,
              eventdate: event.eventday,
              enddate: event.enddate,
              event_date: event.event_day,
              finish_date: event.finish_day,
              theme: event.theme,
              venue: event.venue,
              expectednum: event.expected,
              time: event.time,
              endtime: event.endtime,
              prevpage: 'myevents',
            },
          }}
        >
          <label className="action-btn">View</label>
        </Link>
      </td>
    </tr>
  )
}

const EventsDashboard = () => {
  const [ongoingEvents, setOngoingEvents] = useState(0)
  const [upcomingEvents, setUpcomingEvents] = useState(0)
  const [pastEvents, setPastEvents] = useState(0)
  const [eventList, setEventList] = useState([])
  const [revenue, setRevenue] = useState(0)
  const [netRevenue, setNetRevenue] = useState(0)
  const [loader, setLoader] = useState(true)

  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  const fetchongoingEventsData = async () => {
    Axios.get(`${url}?query=FETCH-EVENT-COUNTS`, { withCredentials: true })
      .then((response) => {
        setOngoingEvents(response.data.ongoing)
        setUpcomingEvents(response.data.upcoming)
        setPastEvents(response.data.past)
        setRevenue(response.data.revenue)
        setNetRevenue(response.data.netRevenue)
      })
      .catch((error) => {
        console.error('Error fetching dashboard data:', error)
      })
  }

  const fetchEvents = async () => {
    Axios.get(`${url}?query=EVENT-LIST`, { withCredentials: true })
      .then((response) => {
        setLoader(false)
        if (response.data.status === 'success') {
          setEventList(response.data.events)
        } else {
          setEventList([])
        }
      })
      .catch((error) => {
        setEventList([])
        console.error('Error fetching dashboard data:', error)
      })
  }

  useEffect(() => {
    fetchongoingEventsData()
    fetchEvents()
  }, [])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentEvents = eventList.slice(indexOfFirstItem, indexOfLastItem)
  const totalPages = Math.ceil(eventList.length / itemsPerPage)
  const accountId = localStorage.getItem('businessid')

  console.log('accountId____d:', accountId)

  return (
    <div className="events-dashboard">
      <div className="dashboard-header">
        <h5 className="dashboard-title mt-2">Dashboard</h5>

        <Link
          className={accountId == 120 ? '' : 'd-none'}
          to={{ pathname: 'index-events', state: { prevpage: 'dashboard' } }}
        >
          <label className="create-event-btn">
            <IoIosAdd size={25} /> Index Events
          </label>
        </Link>

        <Link to={{ pathname: 'addevent', state: { prevpage: 'dashboard' } }}>
          <label className="create-event-btn">
            <IoIosAdd size={25} /> Create Event
          </label>
        </Link>
      </div>

      <div className="summary-grid">
        <SummaryCard
          title="Upcoming Events"
          count={upcomingEvents}
          icon={
            <label className="event-icons-upcoming event-icons d-none d-sm-block">
              <BiCalendar />
            </label>
          }
        />
        <SummaryCard
          title="Ongoing Events"
          count={ongoingEvents}
          icon={
            <label className="event-icons-ongoing event-icons d-none d-sm-block">
              <IoMdHourglass />
            </label>
          }
        />
        <SummaryCard
          title="Past Events"
          count={pastEvents}
          icon={
            <label className="event-icons-past event-icons d-none d-sm-block">
              <BiCheckCircle />
            </label>
          }
        />
        <SummaryCard
          title="Gross"
          count={`R${revenue}`}
          icon={
            <label className="event-icons-refunds event-icons d-none d-sm-block">
              <BiMoney />
            </label>
          }
        />
        <SummaryCard
          title="Net"
          count={`R${netRevenue}`}
          icon={
            <label className="event-icons-past event-icons d-none d-sm-block">
              <BiMoney />
            </label>
          }
        />
      </div>

      <div className="table-container">
        <table className="events-table">
          <thead>
            <tr>
              <th>Organiser</th>
              <th>Event</th>
              <th>Date</th>
              <th>Status</th>
              <th>Complete</th>
              <th>Admit</th>
              <th>Gross</th>
              <th>Net</th>
              <th>Payout</th>
              <th>Visibility</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr className={!loader ? 'd-none' : ''}>
              <td colSpan={11}>
                <div className="w-100 text-center p-3">
                  <ClipLoader
                    color={'grey'}
                    loading={true}
                    // css={override}
                    size={20}
                  />
                </div>
              </td>
            </tr>
            {currentEvents.length === 0 ? (
              <tr className={loader ? 'd-none' : ''}>
                <td colSpan="11" style={{ textAlign: 'center', padding: '20px' }}>
                  No events found.
                  <br />
                  <Link
                    to={{
                      pathname: 'addevent',
                      state: { prevpage: 'dashboard' },
                    }}
                  >
                    <label className="create-event-btn mt-2">
                      <IoIosAdd size={25} /> Create your first event
                    </label>
                  </Link>
                </td>
              </tr>
            ) : (
              currentEvents.map((event, index) => <EventRow key={index} event={event} />)
            )}
          </tbody>
        </table>

        {eventList.length > itemsPerPage && (
          <div className="pagination-controls">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default EventsDashboard
